import VisualizeInstructor from '../components/course/visualize-instructor';
<template><VisualizeInstructor @course={{@model.course}} @user={{@model.user}} /></template>
